/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Siparis_OnaylamaInputs */

const tr_faq_a_siparis_onaylama = /** @type {(inputs: Faq_A_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siparişler ekranında bekleyen siparişleri görürsün. İstediğin siparişi seçip Onayla butonuna basman yeterli. Onaylama işlemi aynı anda fatura oluşturmayı da tetikler; fatura QNB eSolutions üzerinden otomatik kesilir ve pazaryerine iletilir.`)
};

const en_faq_a_siparis_onaylama = /** @type {(inputs: Faq_A_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Orders screen, select a pending order and click Approve. Approval also triggers invoice creation via QNB eSolutions and forwards it to the marketplace.`)
};

const de_faq_a_siparis_onaylama = /** @type {(inputs: Faq_A_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne die Bestellübersicht, wähle eine ausstehende Bestellung und klicke auf Genehmigen. Die Genehmigung löst auch die Rechnungserstellung über QNB eSolutions aus.`)
};

const ru_faq_a_siparis_onaylama = /** @type {(inputs: Faq_A_Siparis_OnaylamaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте раздел Заказы, выберите ожидающий заказ и нажмите Одобрить. Одобрение также запускает выставление счёта через QNB eSolutions.`)
};

/**
* | output |
* | --- |
* | "Open the Orders screen, select a pending order and click Approve. Approval also triggers invoice creation via QNB eSolutions and forwards it to the marketplace." |
*
* @param {Faq_A_Siparis_OnaylamaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_siparis_onaylama = /** @type {((inputs?: Faq_A_Siparis_OnaylamaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Siparis_OnaylamaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_siparis_onaylama(inputs)
	if (locale === "de") return de_faq_a_siparis_onaylama(inputs)
	if (locale === "ru") return ru_faq_a_siparis_onaylama(inputs)
	return tr_faq_a_siparis_onaylama(inputs)
});